<template>
    <div class="user-plan-management">
      <h2 class="page-title">患者计划管理</h2>
  
      <!-- 搜索区域 -->
      <el-card class="search-card">
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
          <el-form-item label="患者姓名">
            <el-input v-model="searchForm.patientName" placeholder="请输入患者姓名" clearable></el-input>
          </el-form-item>
          <el-form-item label="身份证号">
            <el-input v-model="searchForm.idNumber" placeholder="请输入身份证号" clearable></el-input>
          </el-form-item>
          <el-form-item label="计划名称">
            <el-input v-model="searchForm.planName" placeholder="请输入计划名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="计划类型">
            <el-select v-model="searchForm.planType" placeholder="请选择计划类型" clearable>
              <el-option label="随访计划" value="followUp"></el-option>
              <el-option label="健康指导计划" value="healthGuidance"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="执行科室">
            <el-select v-model="searchForm.department" placeholder="请选择科室" clearable>
              <el-option label="全部" value="all"></el-option>
              <el-option label="内科" value="内科"></el-option>
              <el-option label="外科" value="外科"></el-option>
              <el-option label="妇产科" value="妇产科"></el-option>
              <el-option label="儿科" value="儿科"></el-option>
              <el-option label="眼科" value="眼科"></el-option>
              <el-option label="骨科" value="骨科"></el-option>
              <el-option label="神经内科" value="神经内科"></el-option>
              <el-option label="心内科" value="心内科"></el-option>
              <el-option label="肿瘤科" value="肿瘤科"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计划状态">
            <el-select v-model="searchForm.planStatus" placeholder="请选择计划状态" clearable>
              <el-option label="待启动" value="pending"></el-option>
              <el-option label="进行中" value="active"></el-option>
              <el-option label="已结束" value="terminated"></el-option>
              <el-option label="已完成" value="completed"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
  
      <!-- 操作按钮区域 -->
      <div class="operation-container">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增患者计划</el-button>
        <el-button type="danger" icon="el-icon-delete" :disabled="multipleSelection.length === 0" 
          @click="handleBatchDelete">批量删除</el-button>
        <el-button type="success" icon="el-icon-upload2" @click="handleImport">导入</el-button>
        <el-button type="warning" icon="el-icon-download" @click="handleExport">导出</el-button>
      </div>
  
      <!-- 表格区域 -->
      <el-table ref="planTable" :data="tableData" border style="width: 100%" v-loading="loading"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="patientName" label="患者姓名" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="gender" label="性别" width="60">
          <template slot-scope="scope">
            <span>{{ scope.row.gender === 'M' ? '男' : '女' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="age" label="年龄" width="60"></el-table-column>
        <el-table-column prop="idNumber" label="身份证号" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="planName" label="计划名称" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="planType" label="计划类型" width="120">
          <template slot-scope="scope">
            <el-tag size="medium" :type="scope.row.planType === '随访计划' ? 'primary' : 'success'">
              {{ scope.row.planType }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="department" label="执行科室" width="100">
          <template slot-scope="scope">
            <el-tag size="medium" :type="scope.row.department === '全部' ? 'info' : ''">{{ scope.row.department }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="startDate" label="开始日期" width="110"></el-table-column>
        <el-table-column prop="endDate" label="结束日期" width="110"></el-table-column>
        <el-table-column prop="planStatus" label="计划状态" width="100">
          <template slot-scope="scope">
            <el-tag size="medium" :type="getStatusType(scope.row.planStatus)">
              {{ getStatusLabel(scope.row.planStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="任务详情" width="280">
          <template slot-scope="scope">
            <div class="task-statistics">
              <el-tag size="small" type="success">已完成: {{ scope.row.taskStats.completed }}</el-tag>
              <el-tag size="small" type="warning">待执行: {{ scope.row.taskStats.pending }}</el-tag>
              <el-tag size="small" type="info">已跳过: {{ scope.row.taskStats.skipped }}</el-tag>
              <el-tag size="small" type="danger">已过期: {{ scope.row.taskStats.expired }}</el-tag>
              <el-tag size="small" type="primary">执行中: {{ scope.row.taskStats.active }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="280">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-view" @click="handleView(scope.row)">查看</el-button>
            <el-button size="mini" type="success" icon="el-icon-video-play" 
              v-if="scope.row.planStatus === 'pending'" @click="handleActivate(scope.row)">激活</el-button>
            <el-button size="mini" type="danger" icon="el-icon-video-pause" 
              v-if="scope.row.planStatus === 'active'" @click="handleTerminate(scope.row)">结束</el-button>
            <el-button size="mini" type="warning" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
            <el-dropdown trigger="click" @command="(command) => handleCommand(command, scope.row)" size="mini">
              <el-button size="mini" type="info">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="copy" icon="el-icon-document-copy">复制</el-dropdown-item>
                <el-dropdown-item command="delete" icon="el-icon-delete">删除</el-dropdown-item>
                <el-dropdown-item command="message" icon="el-icon-message">发送消息</el-dropdown-item>
                <el-dropdown-item command="note" icon="el-icon-notebook-2">添加备注</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
  
      <!-- 分页区域 -->
      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
        </el-pagination>
      </div>
  
      <!-- 患者计划详情对话框 -->
      <el-dialog title="患者计划详情" :visible.sync="detailDialogVisible" width="900px">
        <div class="plan-detail-header">
          <div class="patient-info">
            <h3>{{ currentPlan.patientName }} 的{{ currentPlan.planType }}</h3>
            <p>身份证号：{{ currentPlan.idNumber }}</p>
            <p>性别：{{ currentPlan.gender === 'M' ? '男' : '女' }}，年龄：{{ currentPlan.age }}岁</p>
            <p>联系电话：{{ currentPlan.phone }}</p>
          </div>
          <div class="plan-info">
            <p><span class="label">计划名称：</span>{{ currentPlan.planName }}</p>
            <p><span class="label">执行科室：</span>{{ currentPlan.department }}</p>
            <p><span class="label">起止时间：</span>{{ currentPlan.startDate }} 至 {{ currentPlan.endDate }}</p>
            <p><span class="label">基准日期：</span>{{ currentPlan.baseDate }}</p>
            <p><span class="label">当前状态：</span>
              <el-tag :type="getStatusType(currentPlan.planStatus)">{{ getStatusLabel(currentPlan.planStatus) }}</el-tag>
            </p>
          </div>
        </div>
  
        <el-divider content-position="center">任务列表</el-divider>
  
        <el-table :data="currentPlan.tasks" border style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="task-detail-expand">
                <p><span class="label">任务内容：</span>{{ props.row.content }}</p>
                <p><span class="label">执行角色：</span>
                  <el-tag v-for="(role, index) in props.row.roles" :key="index" size="small" 
                    style="margin-right: 5px">{{ role }}</el-tag>
                </p>
                <p v-if="props.row.notification && props.row.notification.enabled">
                  <span class="label">通知方式：</span>
                  <el-tag size="small" type="success" 
                    v-if="props.row.notification.sms && props.row.notification.sms.enabled">短信通知</el-tag>
                  <el-tag size="small" type="primary" style="margin-left: 5px"
                    v-if="props.row.notification.internalMsg && props.row.notification.internalMsg.enabled">站内信通知</el-tag>
                </p>
                <div v-if="props.row.result">
                  <p><span class="label">执行结果：</span>{{ props.row.result.comment }}</p>
                  <p><span class="label">执行人：</span>{{ props.row.result.executor }}</p>
                  <p><span class="label">执行时间：</span>{{ props.row.result.executionTime }}</p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="day" label="第几天" width="80"></el-table-column>
          <el-table-column prop="scheduleDate" label="计划执行日期" width="110"></el-table-column>
          <el-table-column prop="content" label="任务内容" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="执行状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="getTaskStatusType(scope.row.status)">{{ getTaskStatusLabel(scope.row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" :disabled="scope.row.status !== 'pending'"
                @click="handleTaskExecute(scope.row)">执行</el-button>
              <el-button size="mini" type="danger" :disabled="scope.row.status !== 'pending'"
                @click="handleTaskSkip(scope.row)">跳过</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
  
      <!-- 新增/编辑患者计划对话框 -->
      <el-dialog :title="dialogTitle" :visible.sync="editDialogVisible" width="800px" :close-on-click-modal="false">
        <el-form :model="planForm" :rules="planRules" ref="planForm" label-width="100px">
          <el-tabs v-model="activeTab">
            <el-tab-pane label="基本信息" name="basicInfo">
              <!-- 患者信息 -->
              <el-divider content-position="left">患者信息</el-divider>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="患者姓名" prop="patientName">
                    <el-input v-model="planForm.patientName" placeholder="请输入患者姓名">
                      <el-button slot="append" icon="el-icon-search" @click="searchPatient"></el-button>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="身份证号" prop="idNumber">
                    <el-input v-model="planForm.idNumber" placeholder="请输入身份证号"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="性别" prop="gender">
                    <el-radio-group v-model="planForm.gender">
                      <el-radio label="M">男</el-radio>
                      <el-radio label="F">女</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="年龄" prop="age">
                    <el-input-number v-model="planForm.age" :min="0" :max="120" style="width: 100%"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="联系电话" prop="phone">
                    <el-input v-model="planForm.phone" placeholder="请输入联系电话"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
  
              <!-- 计划信息 -->
              <el-divider content-position="left">计划信息</el-divider>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="计划模板" prop="templateId">
                    <el-select v-model="planForm.templateId" placeholder="请选择计划模板" style="width: 100%"
                      @change="handleTemplateChange">
                      <el-option v-for="item in templates" :key="item.id" :label="item.templateName"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="计划名称" prop="planName">
                    <el-input v-model="planForm.planName" placeholder="请输入计划名称"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="计划类型" prop="planType">
                    <el-radio-group v-model="planForm.planType">
                      <el-radio label="随访计划">随访计划</el-radio>
                      <el-radio label="健康指导计划">健康指导计划</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="执行科室" prop="department">
                    <el-select v-model="planForm.department" placeholder="请选择科室" style="width: 100%">
                      <el-option label="全部" value="全部"></el-option>
                      <el-option label="内科" value="内科"></el-option>
                      <el-option label="外科" value="外科"></el-option>
                      <el-option label="妇产科" value="妇产科"></el-option>
                      <el-option label="儿科" value="儿科"></el-option>
                      <el-option label="眼科" value="眼科"></el-option>
                      <el-option label="骨科" value="骨科"></el-option>
                      <el-option label="神经内科" value="神经内科"></el-option>
                      <el-option label="心内科" value="心内科"></el-option>
                      <el-option label="肿瘤科" value="肿瘤科"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="基准日期" prop="baseDateInfo">
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-select v-model="planForm.baseDateType" placeholder="请选择基准日期类型" style="width: 100%">
                          <el-option label="入组时间" value="enrollment_date"></el-option>
                          <el-option label="末次月经" value="last_menstruation"></el-option>
                          <el-option label="出生日期" value="birth_date"></el-option>
                          <el-option label="手术日期" value="operation_date"></el-option>
                          <el-option label="出院日期" value="discharge_date"></el-option>
                          <el-option label="确诊日期" value="diagnosis_date"></el-option>
                          <el-option label="首次就诊" value="first_visit"></el-option>
                          <el-option label="最近随访" value="last_visit"></el-option>
                          <el-option label="自定义日期" value="custom_date"></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="12">
                        <el-date-picker v-model="planForm.baseDate" type="date" 
                          placeholder="请选择基准日期" style="width: 100%" value-format="yyyy-MM-dd">
                        </el-date-picker>
                      </el-col>
                    </el-row>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="周期(天)" prop="period">
                    <el-input-number v-model="planForm.period" :min="1" :max="1000" style="width: 100%"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="执行时间" prop="executionTime.type">
                    <el-radio-group v-model="planForm.executionTime.type">
                      <el-radio label="immediate">立即执行</el-radio>
                      <el-radio label="delay">延迟执行</el-radio>
                    </el-radio-group>
                    <div v-if="planForm.executionTime.type === 'delay'" style="margin-top: 10px">
                      <span>从基准日期起第</span>
                      <el-input-number v-model="planForm.executionTime.days" :min="0" :max="100" 
                        style="width: 120px"></el-input-number>
                      <span>天开始执行</span>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="计划状态" prop="planStatus">
                <el-radio-group v-model="planForm.planStatus">
                  <el-radio label="pending">待启动</el-radio>
                  <el-radio label="active">进行中</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="备注">
                <el-input type="textarea" v-model="planForm.remark" :rows="3" 
                  placeholder="请输入备注信息"></el-input>
              </el-form-item>
            </el-tab-pane>
  
            <el-tab-pane label="任务设置" name="taskSetting">
              <div class="task-setting-header">
                <div class="header-title">患者随访任务配置</div>
                <el-button type="primary" size="small" icon="el-icon-plus" @click="addTask">新增任务</el-button>
              </div>
  
              <div class="tasks-container">
                <el-table :data="planForm.tasks" border style="width: 100%">
                  <el-table-column prop="day" label="第几天" width="80">
                    <template slot-scope="scope">
                      <el-input-number v-model="scope.row.day" :min="1" :max="planForm.period" 
                        size="small" style="width: 80px"></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column prop="content" label="任务内容" min-width="200">
                    <template slot-scope="scope">
                      <el-input type="textarea" v-model="scope.row.content" :rows="2" 
                        placeholder="请输入任务内容描述"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="roles" label="执行角色" width="220">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.roles" multiple placeholder="请选择执行角色" size="small" 
                        style="width: 100%">
                        <el-option label="患者" value="患者"></el-option>
                        <el-option label="个管师" value="个管师"></el-option>
                        <el-option label="医助" value="医助"></el-option>
                        <el-option label="领衔专家" value="领衔专家"></el-option>
                        <el-option label="执行医生" value="执行医生"></el-option>
                        <el-option label="护士" value="护士"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="notification" label="通知设置" width="120">
                    <template slot-scope="scope">
                      <el-switch v-model="scope.row.notification.enabled" active-text="推送用户" 
                        inactive-text="不推送" @change="ensureNotificationStructure(scope.row)"></el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                      <el-button size="mini" type="text" icon="el-icon-edit" 
                        @click="handleTaskEdit(scope.$index, scope.row)">编辑</el-button>
                      <el-button size="mini" type="text" icon="el-icon-delete" 
                        @click="removeTask(scope.$index)" 
                        :disabled="planForm.tasks.length <= 1">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
      </el-dialog>
  
      <!-- 任务通知设置对话框 -->
      <el-dialog title="任务通知设置" :visible.sync="taskNotifyDialogVisible" width="700px" :close-on-click-modal="false"
        append-to-body>
        <el-form :model="currentTask" ref="taskNotifyForm" label-width="100px">
          <el-form-item label="推送用户">
            <el-switch v-model="currentTask.notification.enabled" active-text="是" inactive-text="否"></el-switch>
          </el-form-item>
  
          <div v-if="currentTask.notification.enabled" class="notification-settings">
            <el-form-item label="短信通知">
              <el-switch v-model="currentTask.notification.sms.enabled" active-text="启用" 
                inactive-text="禁用"></el-switch>
            </el-form-item>
  
            <el-form-item v-if="currentTask.notification.sms.enabled" label="短信模板">
              <div class="template-input-container">
                <el-input type="textarea" v-model="currentTask.notification.sms.template" :rows="4"
                  placeholder="请输入短信模板内容，可使用变量如${patient_name}"></el-input>
                <div class="template-tips">
                  <div class="tips-title">模板变量说明：</div>
                  <div class="tips-item">${patient_name} - 患者姓名</div>
                  <div class="tips-item">${doctor_name} - 医生姓名</div>
                  <div class="tips-item">${hospital_name} - 医院名称</div>
                  <div class="tips-item">${task_day} - 任务天数</div>
                  <div class="tips-item">${date} - 当前日期</div>
                </div>
              </div>
            </el-form-item>
  
            <el-form-item label="站内信通知">
              <el-switch v-model="currentTask.notification.internalMsg.enabled" active-text="启用" 
                inactive-text="禁用"></el-switch>
            </el-form-item>
  
            <el-form-item v-if="currentTask.notification.internalMsg.enabled" label="站内信模板">
              <div class="template-input-container">
                <el-input type="textarea" v-model="currentTask.notification.internalMsg.template" :rows="4"
                  placeholder="请输入站内信模板内容，可使用变量如${patient_name}"></el-input>
                <div class="template-tips">
                  <div class="tips-title">模板变量说明：</div>
                  <div class="tips-item">${patient_name} - 患者姓名</div>
                  <div class="tips-item">${doctor_name} - 医生姓名</div>
                  <div class="tips-item">${hospital_name} - 医院名称</div>
                  <div class="tips-item">${task_day} - 任务天数</div>
                  <div class="tips-item">${date} - 当前日期</div>
                  <div class="tips-item">${time} - 当前时间</div>
                </div>
              </div>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="taskNotifyDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveTaskNotify">确 定</el-button>
        </div>
      </el-dialog>
  
      <!-- 任务执行对话框 -->
      <el-dialog title="任务执行" :visible.sync="taskExecuteDialogVisible" width="600px">
        <el-form :model="executeForm" ref="executeForm" label-width="100px">
          <el-form-item label="患者姓名">
            <span>{{ currentPlan.patientName }}</span>
          </el-form-item>
          <el-form-item label="任务内容">
            <span>{{ currentTask.content }}</span>
          </el-form-item>
          <el-form-item label="计划日期">
            <span>{{ currentTask.scheduleDate }}</span>
          </el-form-item>
          <el-form-item label="执行结果" prop="comment">
            <el-input type="textarea" v-model="executeForm.comment" :rows="4" 
              placeholder="请输入执行结果或备注信息"></el-input>
          </el-form-item>
          <el-form-item label="执行人" prop="executor">
            <el-input v-model="executeForm.executor" placeholder="请输入执行人姓名"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="taskExecuteDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmTaskExecute">确认执行</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
export default {
  name: "UserPlanManagement",
  data() {
    return {
      // 搜索表单
      searchForm: {
        patientName: '',
        idNumber: '',
        planName: '',
        planType: '',
        department: '',
        planStatus: ''
      },
      // 表格数据
      tableData: [],
      // 表格加载状态
      loading: false,
      // 多选数据
      multipleSelection: [],
      // 分页参数
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 当前计划详情
      currentPlan: {
        patientName: '',
        idNumber: '',
        gender: 'M',
        age: 0,
        phone: '',
        planName: '',
        planType: '',
        department: '',
        startDate: '',
        endDate: '',
        baseDate: '',
        planStatus: '',
        tasks: []
      },
      // 当前编辑的任务
      currentTask: {
        day: 1,
        content: '',
        roles: [],
        notification: {
          enabled: false,
          sms: {
            enabled: false,
            template: ''
          },
          internalMsg: {
            enabled: false,
            template: ''
          }
        }
      },
      // 执行表单
      executeForm: {
        comment: '',
        executor: ''
      },
      // 模板数据
      templates: [
        { id: 1, templateName: '糖尿病随访计划模板' },
        { id: 2, templateName: '高血压随访计划模板' },
        { id: 3, templateName: '孕产妇随访计划模板' },
        { id: 4, templateName: '慢阻肺随访计划模板' },
        { id: 5, templateName: '心理健康指导计划模板' },
        { id: 6, templateName: '术后护理指导计划模板' }
      ],
      // 计划表单
      planForm: {
        patientName: '',
        idNumber: '',
        gender: 'M',
        age: 30,
        phone: '',
        templateId: '',
        planName: '',
        planType: '随访计划',
        department: '',
        baseDateType: 'custom_date',
        baseDate: '',
        period: 30,
        executionTime: {
          type: 'immediate',
          days: 0
        },
        planStatus: 'pending',
        remark: '',
        tasks: [
          {
            day: 1,
            content: '首次随访，评估基础情况',
            roles: ['个管师'],
            notification: {
              enabled: false,
              sms: {
                enabled: false,
                template: ''
              },
              internalMsg: {
                enabled: false,
                template: ''
              }
            }
          }
        ]
      },
      // 表单验证规则
      planRules: {
        patientName: [
          { required: true, message: '请输入患者姓名', trigger: 'blur' }
        ],
        idNumber: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        gender: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        age: [
          { required: true, message: '请输入年龄', trigger: 'change' }
        ],
        phone: [
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        planName: [
          { required: true, message: '请输入计划名称', trigger: 'blur' }
        ],
        planType: [
          { required: true, message: '请选择计划类型', trigger: 'change' }
        ],
        department: [
          { required: true, message: '请选择执行科室', trigger: 'change' }
        ],
        baseDate: [
          { required: true, message: '请选择基准日期', trigger: 'change' }
        ],
        period: [
          { required: true, message: '请设置周期天数', trigger: 'change' }
        ]
      },
      // 对话框可见性
      detailDialogVisible: false,
      editDialogVisible: false,
      taskNotifyDialogVisible: false,
      taskExecuteDialogVisible: false,
      // 编辑对话框标题
      dialogTitle: '新增患者计划',
      // 标签页激活名称
      activeTab: 'basicInfo',
      // 当前任务索引
      currentTaskIndex: -1
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    // 获取数据
    fetchData() {
      this.loading = true;
      // 模拟异步请求
      setTimeout(() => {
        this.tableData = this.generateMockData();
        this.pagination.total = this.tableData.length;
        this.loading = false;
      }, 500);
    },
    
    // 生成模拟数据
    generateMockData() {
      const mockData = [];
      const departments = ['内科', '外科', '妇产科', '儿科', '眼科', '骨科', '神经内科', '心内科', '肿瘤科', '全部'];
      const planTypes = ['随访计划', '健康指导计划'];
      const planStatus = ['pending', 'active', 'terminated', 'completed'];
      const statusLabels = {
        pending: '待启动',
        active: '进行中',
        terminated: '已结束',
        completed: '已完成'
      };
      
      for (let i = 1; i <= 30; i++) {
        const gender = Math.random() > 0.5 ? 'M' : 'F';
        const age = Math.floor(Math.random() * 70 + 10);
        const planType = planTypes[Math.floor(Math.random() * planTypes.length)];
        const department = departments[Math.floor(Math.random() * departments.length)];
        const status = planStatus[Math.floor(Math.random() * planStatus.length)];
        
        // 生成模拟身份证号
        const idNumber = '11010' + (1950 + Math.floor(Math.random() * 50)) 
          + (Math.floor(Math.random() * 12) + 1).toString().padStart(2, '0')
          + (Math.floor(Math.random() * 28) + 1).toString().padStart(2, '0')
          + Math.floor(Math.random() * 10000).toString().padStart(4, '0');
        
        // 生成开始日期和结束日期
        const startDate = new Date();
        startDate.setDate(startDate.getDate() - Math.floor(Math.random() * 60));
        const endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + Math.floor(Math.random() * 60) + 30);
        
        const startDateStr = this.formatDate(startDate);
        const endDateStr = this.formatDate(endDate);
        const baseDate = this.formatDate(startDate);
        
        mockData.push({
          id: i,
          patientName: `患者${i}`,
          gender: gender,
          age: age,
          idNumber: idNumber,
          phone: '1' + Math.floor(Math.random() * 9 + 3) + Array(9).fill(0).map(() => Math.floor(Math.random() * 10)).join(''),
          planName: `${department}${planType}${i}`,
          planType: planType,
          department: department,
          startDate: startDateStr,
          endDate: endDateStr,
          baseDate: baseDate,
          planStatus: status,
          remark: `这是患者${i}的${planType}备注信息`,
          taskStats: {
            completed: Math.floor(Math.random() * 5),
            pending: Math.floor(Math.random() * 5),
            skipped: Math.floor(Math.random() * 3),
            expired: Math.floor(Math.random() * 2),
            active: Math.floor(Math.random() * 2)
          },
          tasks: this.generateMockTasks(startDateStr)
        });
      }
      
      return mockData;
    },
    
    // 生成模拟任务
    generateMockTasks(startDate) {
      const taskStatuses = ['completed', 'pending', 'skipped', 'expired', 'active'];
      const roles = ['患者', '个管师', '医助', '领衔专家', '执行医生', '护士'];
      const tasks = [];
      const taskCount = Math.floor(Math.random() * 8) + 3;
      
      for (let i = 0; i < taskCount; i++) {
        const day = i + 1;
        const taskDate = new Date(startDate);
        taskDate.setDate(taskDate.getDate() + day - 1);
        
        const status = taskStatuses[Math.floor(Math.random() * taskStatuses.length)];
        const selectedRoles = [];
        const roleCount = Math.floor(Math.random() * 3) + 1;
        
        for (let j = 0; j < roleCount; j++) {
          const role = roles[Math.floor(Math.random() * roles.length)];
          if (!selectedRoles.includes(role)) {
            selectedRoles.push(role);
          }
        }
        
        const task = {
          day: day,
          scheduleDate: this.formatDate(taskDate),
          content: `第${day}天随访任务：${this.getRandomTaskContent(day)}`,
          status: status,
          roles: selectedRoles,
          notification: {
            enabled: Math.random() > 0.5,
            sms: {
              enabled: Math.random() > 0.5,
              template: `尊敬的\${patient_name}，您有一项随访任务需要在\${date}完成，请按时参与。`
            },
            internalMsg: {
              enabled: Math.random() > 0.5,
              template: `尊敬的\${patient_name}，您有一项随访任务需要在\${date} \${time}完成，请按时参与。`
            }
          }
        };
        
        // 为已完成的任务添加结果
        if (status === 'completed') {
          task.result = {
            comment: `已完成第${day}天随访，患者状态良好。`,
            executor: `医生${Math.floor(Math.random() * 10) + 1}`,
            executionTime: this.formatDate(new Date(taskDate.getTime() + 86400000 * Math.random()))
          };
        }
        
        tasks.push(task);
      }
      
      return tasks;
    },
    
    // 随机生成任务内容
    getRandomTaskContent(day) {
      const taskContents = [
        "测量血压并记录结果",
        "测量血糖并记录结果",
        "进行电话随访，了解患者用药情况",
        "门诊复查，评估治疗效果",
        "健康教育，饮食指导",
        "心理评估与指导",
        "专家会诊",
        "线上问题解答",
        "药物调整建议",
        "生活方式干预指导"
      ];
      
      return taskContents[Math.floor(Math.random() * taskContents.length)];
    },
    
    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    
    // 获取计划状态类型
    getStatusType(status) {
      const statusMap = {
        pending: 'warning',
        active: 'primary',
        terminated: 'danger',
        completed: 'success'
      };
      return statusMap[status] || 'info';
    },
    
    // 获取计划状态标签
    getStatusLabel(status) {
      const statusMap = {
        pending: '待启动',
        active: '进行中',
        terminated: '已结束',
        completed: '已完成'
      };
      return statusMap[status] || status;
    },
    
    // 获取任务状态类型
    getTaskStatusType(status) {
      const statusMap = {
        pending: 'warning',
        active: 'primary',
        completed: 'success',
        skipped: 'info',
        expired: 'danger'
      };
      return statusMap[status] || 'info';
    },
    
    // 获取任务状态标签
    getTaskStatusLabel(status) {
      const statusMap = {
        pending: '待执行',
        active: '执行中',
        completed: '已完成',
        skipped: '已跳过',
        expired: '已过期'
      };
      return statusMap[status] || status;
    },
    
    // 处理搜索
    handleSearch() {
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    
    // 重置搜索
    resetSearch() {
      this.$refs.searchForm.resetFields();
      this.handleSearch();
    },
    
    // 处理多选变化
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    
    // 处理页大小变化
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.fetchData();
    },
    
    // 处理当前页变化
    handleCurrentChange(page) {
      this.pagination.currentPage = page;
      this.fetchData();
    },
    
    // 处理查看详情
    handleView(row) {
      this.currentPlan = JSON.parse(JSON.stringify(row));
      this.detailDialogVisible = true;
    },
    
    // 处理激活计划
    handleActivate(row) {
      this.$confirm('确认要激活该患者计划吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '计划激活成功!'
        });
        row.planStatus = 'active';
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消激活'
        });
      });
    },
    
    // 处理结束计划
    handleTerminate(row) {
      this.$confirm('确认要结束该患者计划吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '计划已结束!'
        });
        row.planStatus = 'terminated';
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    
    // 处理编辑计划
    handleEdit(row) {
      this.dialogTitle = '编辑患者计划';
      this.planForm = JSON.parse(JSON.stringify(row));
      // 确保每个任务有正确的通知结构
      this.planForm.tasks.forEach(task => {
        this.ensureNotificationStructure(task);
      });
      this.activeTab = 'basicInfo';
      this.editDialogVisible = true;
    },
    
    // 处理添加计划
    handleAdd() {
      this.dialogTitle = '新增患者计划';
      this.planForm = {
        patientName: '',
        idNumber: '',
        gender: 'M',
        age: 30,
        phone: '',
        templateId: '',
        planName: '',
        planType: '随访计划',
        department: '',
        baseDateType: 'custom_date',
        baseDate: this.formatDate(new Date()),
        period: 30,
        executionTime: {
          type: 'immediate',
          days: 0
        },
        planStatus: 'pending',
        remark: '',
        tasks: [
          {
            day: 1,
            content: '首次随访，评估基础情况',
            roles: ['个管师'],
            notification: {
              enabled: false,
              sms: {
                enabled: false,
                template: ''
              },
              internalMsg: {
                enabled: false,
                template: ''
              }
            }
          }
        ]
      };
      this.activeTab = 'basicInfo';
      this.editDialogVisible = true;
    },
    
    // 处理导入
    handleImport() {
      this.$message({
        message: '导入功能正在开发中...',
        type: 'info'
      });
    },
    
    // 处理导出
    handleExport() {
      this.$message({
        message: '导出功能正在开发中...',
        type: 'info'
      });
    },
    
    // 处理批量删除
    handleBatchDelete() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请至少选择一条记录',
          type: 'warning'
        });
        return;
      }
      
      this.$confirm(`确认删除选中的 ${this.multipleSelection.length} 条计划记录吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 模拟删除
        this.multipleSelection.forEach(item => {
          const index = this.tableData.findIndex(row => row.id === item.id);
          if (index !== -1) {
            this.tableData.splice(index, 1);
          }
        });
        this.pagination.total = this.tableData.length;
        this.$message({
          type: 'success',
          message: '批量删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    
    // 处理下拉菜单命令
    handleCommand(command, row) {
      switch (command) {
        case 'copy':
          this.handleCopy(row);
          break;
        case 'delete':
          this.handleDelete(row);
          break;
        case 'message':
          this.handleSendMessage(row);
          break;
        case 'note':
          this.handleAddNote(row);
          break;
        default:
          break;
      }
    },
    
    // 处理复制计划
    handleCopy(row) {
      const newPlan = JSON.parse(JSON.stringify(row));
      newPlan.id = this.tableData.length + 1;
      newPlan.planName = `${newPlan.planName} - 副本`;
      newPlan.planStatus = 'pending';
      this.tableData.unshift(newPlan);
      this.pagination.total = this.tableData.length;
      this.$message({
        message: '计划已复制',
        type: 'success'
      });
    },
    
    // 处理删除计划
    handleDelete(row) {
      this.$confirm('确认删除该患者计划吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const index = this.tableData.findIndex(item => item.id === row.id);
        if (index !== -1) {
          this.tableData.splice(index, 1);
        }
        this.pagination.total = this.tableData.length;
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    
    // 处理发送消息
    handleSendMessage(row) {
      this.$prompt('请输入要发送给患者的消息', '发送消息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入消息内容'
      }).then(({ value }) => {
        this.$message({
          type: 'success',
          message: `消息已发送至患者 ${row.patientName}`
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消发送'
        });
      });
    },
    
    // 处理添加备注
    handleAddNote(row) {
      this.$prompt('请输入患者计划备注', '添加备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: row.remark || '',
        inputPlaceholder: '请输入备注内容'
      }).then(({ value }) => {
        row.remark = value;
        this.$message({
          type: 'success',
          message: '备注已添加'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消添加'
        });
      });
    },
    
    // 搜索患者
    searchPatient() {
      if (!this.planForm.patientName) {
        this.$message({
          message: '请输入患者姓名进行搜索',
          type: 'warning'
        });
        return;
      }
      
      // 模拟搜索患者
      setTimeout(() => {
        this.planForm.idNumber = '110105199001012345';
        this.planForm.gender = 'M';
        this.planForm.age = 33;
        this.planForm.phone = '13812345678';
        this.$message({
          message: '已找到患者信息',
          type: 'success'
        });
      }, 500);
    },
    
    // 处理模板变更
    handleTemplateChange(val) {
      const template = this.templates.find(item => item.id === val);
      if (template) {
        this.planForm.planName = template.templateName.replace('模板', '');
        this.planForm.planType = template.templateName.includes('指导') ? '健康指导计划' : '随访计划';
        // 根据模板设置更多字段...
      }
    },
    
    // 提交表单
    submitForm() {
      this.$refs.planForm.validate((valid) => {
        if (valid) {
          // 模拟提交
          this.loading = true;
          setTimeout(() => {
            if (this.dialogTitle === '新增患者计划') {
              // 新增
              const newPlan = JSON.parse(JSON.stringify(this.planForm));
              newPlan.id = this.tableData.length + 1;
              newPlan.startDate = this.planForm.baseDate;
              
              // 计算结束日期
              const endDate = new Date(this.planForm.baseDate);
              endDate.setDate(endDate.getDate() + this.planForm.period);
              newPlan.endDate = this.formatDate(endDate);
              
              // 添加任务状态统计
              newPlan.taskStats = {
                completed: 0,
                pending: this.planForm.tasks.length,
                skipped: 0,
                expired: 0,
                active: 0
              };
              
              // 设置任务日期
              newPlan.tasks.forEach(task => {
                const taskDate = new Date(this.planForm.baseDate);
                taskDate.setDate(taskDate.getDate() + task.day - 1);
                task.scheduleDate = this.formatDate(taskDate);
                task.status = 'pending';
              });
              
              this.tableData.unshift(newPlan);
              this.pagination.total = this.tableData.length;
              this.$message({
                message: '新增计划成功',
                type: 'success'
              });
            } else {
              // 编辑
              const index = this.tableData.findIndex(item => item.id === this.planForm.id);
              if (index !== -1) {
                const updatedPlan = JSON.parse(JSON.stringify(this.planForm));
                
                // 更新结束日期
                const endDate = new Date(this.planForm.baseDate);
                endDate.setDate(endDate.getDate() + this.planForm.period);
                updatedPlan.endDate = this.formatDate(endDate);
                
                // 更新任务日期
                updatedPlan.tasks.forEach(task => {
                  const taskDate = new Date(this.planForm.baseDate);
                  taskDate.setDate(taskDate.getDate() + task.day - 1);
                  task.scheduleDate = this.formatDate(taskDate);
                });
                
                this.tableData.splice(index, 1, updatedPlan);
                this.$message({
                  message: '更新计划成功',
                  type: 'success'
                });
              }
            }
            
            this.loading = false;
            this.editDialogVisible = false;
          }, 500);
        } else {
          return false;
        }
      });
    },
    
    // 添加任务
    addTask() {
      if (this.planForm.period <= 0) {
        this.$message({
          message: '请先设置有效的周期天数',
          type: 'warning'
        });
        return;
      }
      
      // 找到当前最大的天数
      let maxDay = 1;
      if (this.planForm.tasks.length > 0) {
        maxDay = Math.max(...this.planForm.tasks.map(task => task.day)) + 1;
      }
      
      // 确保不超过周期天数
      if (maxDay > this.planForm.period) {
        maxDay = this.planForm.period;
      }
      
      const newTask = {
        day: maxDay,
        content: '',
        roles: [],
        notification: {
          enabled: false,
          sms: {
            enabled: false,
            template: ''
          },
          internalMsg: {
            enabled: false,
            template: ''
          }
        }
      };
      
      this.planForm.tasks.push(newTask);
    },
    
    // 删除任务
    removeTask(index) {
      if (this.planForm.tasks.length <= 1) {
        this.$message({
          message: '至少需要保留一项任务',
          type: 'warning'
        });
        return;
      }
      this.planForm.tasks.splice(index, 1);
    },
    
    // 确保任务通知结构完整
    ensureNotificationStructure(task) {
      if (!task.notification) {
        task.notification = {
          enabled: false,
          sms: {
            enabled: false,
            template: ''
          },
          internalMsg: {
            enabled: false,
            template: ''
          }
        };
      } else {
        if (!task.notification.sms) {
          task.notification.sms = {
            enabled: false,
            template: ''
          };
        }
        if (!task.notification.internalMsg) {
          task.notification.internalMsg = {
            enabled: false,
            template: ''
          };
        }
      }
      
      return task;
    },
    
    // 处理任务编辑
    handleTaskEdit(index, task) {
      this.currentTaskIndex = index;
      this.currentTask = this.ensureNotificationStructure(JSON.parse(JSON.stringify(task)));
      this.taskNotifyDialogVisible = true;
    },
    
    // 保存任务通知设置
    saveTaskNotify() {
      if (this.currentTaskIndex >= 0 && this.currentTaskIndex < this.planForm.tasks.length) {
        this.planForm.tasks[this.currentTaskIndex].notification = JSON.parse(JSON.stringify(this.currentTask.notification));
        this.$message({
          message: '通知设置已保存',
          type: 'success'
        });
      }
      this.taskNotifyDialogVisible = false;
    },
    
    // 处理任务执行
    handleTaskExecute(task) {
      this.currentTask = JSON.parse(JSON.stringify(task));
      this.executeForm = {
        comment: '',
        executor: ''
      };
      this.taskExecuteDialogVisible = true;
    },
    
    // 处理任务跳过
    handleTaskSkip(task) {
      this.$confirm('确认要跳过该任务吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        task.status = 'skipped';
        this.$message({
          type: 'success',
          message: '任务已跳过!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    
    // 确认任务执行
    confirmTaskExecute() {
      if (!this.executeForm.comment || !this.executeForm.executor) {
        this.$message({
          message: '请填写执行结果和执行人',
          type: 'warning'
        });
        return;
      }
      
      // 查找并更新任务状态
      const task = this.currentPlan.tasks.find(
        t => t.day === this.currentTask.day && t.content === this.currentTask.content
      );
      
      if (task) {
        task.status = 'completed';
        task.result = {
          comment: this.executeForm.comment,
          executor: this.executeForm.executor,
          executionTime: this.formatDate(new Date())
        };
        
        // 更新任务统计
        this.currentPlan.taskStats.completed += 1;
        this.currentPlan.taskStats.pending -= 1;
        
        this.$message({
          message: '任务执行成功',
          type: 'success'
        });
      }
      
      this.taskExecuteDialogVisible = false;
    }
  }
}
</script>

<style scoped>
.user-plan-management {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 84px);
}

.page-title {
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 22px;
  font-weight: 600;
  color: #303133;
}

.search-card {
  margin-bottom: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.operation-container {
  margin-bottom: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.el-table .warning-row {
  background-color: #fdf6ec;
}

.el-table .success-row {
  background-color: #f0f9eb;
}

.el-table .danger-row {
  background-color: #fef0f0;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* 任务统计标签样式 */
.task-statistics {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.task-statistics .el-tag {
  margin-right: 0;
}

/* 详情对话框样式 */
.plan-detail-header {
  display: flex;
  margin-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 20px;
}

.patient-info {
  flex: 1;
  padding-right: 20px;
}

.patient-info h3 {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: 600;
}

.patient-info p {
  margin: 8px 0;
  color: #606266;
  font-size: 14px;
}

.plan-info {
  flex: 1;
  padding-left: 20px;
  border-left: 1px solid #ebeef5;
}

.plan-info p {
  margin: 8px 0;
  color: #606266;
  font-size: 14px;
}

.label {
  font-weight: 600;
  color: #303133;
  margin-right: 5px;
}

.task-detail-expand {
  padding: 12px;
  background-color: #f9fafc;
}

.task-detail-expand p {
  margin: 8px 0;
  font-size: 14px;
  color: #606266;
}

/* 任务设置区域样式 */
.task-setting-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.header-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.tasks-container {
  margin-bottom: 20px;
}

/* 通知设置区域样式 */
.notification-settings {
  padding: 16px;
  background-color: #f9fafc;
  border-radius: 4px;
  margin-top: 10px;
  border: 1px solid #ebeef5;
}

.template-input-container {
  display: flex;
  gap: 16px;
}

.template-input-container .el-input {
  flex: 2;
}

.template-tips {
  flex: 1;
  padding: 8px 12px;
  background-color: #ecf5ff;
  border-radius: 4px;
  font-size: 12px;
  color: #409eff;
}

.tips-title {
  font-weight: 600;
  margin-bottom: 8px;
}

.tips-item {
  margin-bottom: 6px;
}

/* 表单分隔线样式调整 */
.el-divider__text {
  background-color: #f5f7fa;
  font-weight: 600;
  color: #409eff;
}

/* 编辑对话框内容滚动 */
.el-dialog__body {
  max-height: 60vh;
  overflow-y: auto;
}

/* 标签页样式调整 */
.el-tabs__nav-wrap::after {
  height: 1px;
}

.el-tabs__active-bar {
  height: 3px;
}

/* 表格内标签样式 */
.el-table .el-tag {
  margin: 2px 0;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .plan-detail-header {
    flex-direction: column;
  }
  
  .patient-info {
    padding-right: 0;
    padding-bottom: 15px;
  }
  
  .plan-info {
    padding-left: 0;
    padding-top: 15px;
    border-left: none;
    border-top: 1px solid #ebeef5;
  }
  
  .template-input-container {
    flex-direction: column;
  }
}

/* 审核状态样式 */
.status-pending {
  color: #e6a23c;
}

.status-active {
  color: #409eff;
}

.status-terminated {
  color: #f56c6c;
}

.status-completed {
  color: #67c23a;
}

/* 表格行多选框居中 */
.el-table .cell .el-checkbox {
  display: flex;
  align-items: center;
  height: 100%;
}

/* 表单元素全宽展示 */
.el-form-item__content .el-input,
.el-form-item__content .el-select,
.el-form-item__content .el-date-editor,
.el-form-item__content .el-input-number {
  width: 100%;
}

/* 表格中的操作按钮间距 */
.el-button + .el-button,
.el-button + .el-dropdown {
  margin-left: 5px;
}

/* 对话框中任务列表的样式 */
.el-dialog .el-table {
  margin-top: 10px;
}

/* 表单校验出错时的提示样式 */
.el-form-item.is-error .el-input__inner,
.el-form-item.is-error .el-textarea__inner {
  border-color: #f56c6c;
}

/* 输入框内的清除按钮样式 */
.el-input__clear {
  color: #c0c4cc;
}

/* 多选下拉框标签样式 */
.el-select .el-tag {
  margin: 2px 0 2px 6px;
}

/* 日期选择器样式调整 */
.el-date-editor.el-input {
  width: 100%;
}

/* 单选按钮组样式调整 */
.el-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

/* 表格内的展开行 */
.el-table__expanded-cell {
  padding: 16px;
}

/* 执行人详情样式 */
.executor-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.executor-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #409eff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

/* 确保文本不会溢出容器 */
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>